export const GTM_EVENTS = {
  DEMO_REQUEST: 'demo_request',
  CTA_CLICK: 'cta_click',
  CONTACT_SUBMIT: 'contact_form_submit',
  PLAN_VIEW: 'plan_view',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  SHARE: 'share',
};

export const GTM_SOURCES = {
  HERO: 'hero',
  NAVBAR: 'navbar',
  NAVBAR_MOBILE: 'navbar_mobile',
  METODOLOGIA_HERO: 'metodologia_hero',
  METODOLOGIA_CTA: 'metodologia_cta',
  TECNOLOGIA_HERO: 'tecnologia_hero',
  TECNOLOGIA_CTA: 'tecnologia_cta',
  PLATAFORMA_HERO: 'plataforma_hero',
  PLATAFORMA_CTA: 'plataforma_cta',
  SEO_HERO: 'seo_hero',
  SEO_CTA: 'seo_cta',
  AGENCIAS_HERO: 'agencias_hero',
  AGENCIAS_CTA: 'agencias_cta',
  COMPARATIVAS_HERO: 'comparativas_hero',
  COMPARATIVAS_CTA: 'comparativas_cta',
  PLANES_HERO: 'planes_hero',
  PLANES_CTA: 'planes_cta',
  PLANES_ADDONS: 'planes_addons',
  CTA_STRIP: 'cta_strip',
  CASOS_HERO: 'casos_hero',
  CASOS_CTA: 'casos_cta',
  NOSOTROS_CTA: 'nosotros_cta',
  AUTOR_HERO: 'autor_hero',
  CONTACTO_HERO: 'contacto_hero',
  CONTACTO_FORM: 'contacto_form',
  CONTACTO_ATAJO: 'contacto_atajo',
  CONTACTO_CTA: 'contacto_cta',
  PLAYBOOK_HERO: 'playbook_hero',
  PLAYBOOK_CTA: 'playbook_cta',
  BLOG: 'blog',
  BLOG_CTA: 'blog_cta',
  BLOG_NEWSLETTER: 'blog_newsletter',
  ACTUALIDAD: 'actualidad',
  ACTUALIDAD_CTA: 'actualidad_cta',
  ACTUALIDAD_NEWSLETTER: 'actualidad_newsletter',
  RANKINGS_CTA: 'rankings_cta',
  NOT_FOUND: 'not_found',
};
